"use client"

import { ErrorBoundaryCard } from "@/components/shared/error-boundary-card"

export default function RootErrorBoundary({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  return (
    <ErrorBoundaryCard
      error={error}
      reset={reset}
      scope="app_root"
      contextLabel="The app"
      className="min-h-svh bg-canvas-workspace"
    />
  )
}
